module.exports = __webpack_public_path__ + "img/vicon5.989d129d.png";